var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplele(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 65,
    viewBox: "0 0 72 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000208707 60.7679V9.80817C0.000208707 7.80291 1.64992 6.26908 3.53561 6.26908H48.6682L41.5974 13.3464H7.18822V57.1105H50.9067V38.4724L58.095 31.2767V60.6493C58.095 62.6546 56.4452 64.1884 54.5596 64.1884H3.65282C1.64965 64.3061 0 62.6546 0 60.7671L0.000208707 60.7679ZM23.5681 25.4972C21.4475 23.3743 17.9121 23.3743 15.7905 25.4972C14.7301 26.5586 14.1408 27.9748 14.1408 29.3899C14.1408 30.8051 14.7302 32.2212 15.7905 33.2827L27.3386 44.8428C29.4593 46.9657 32.9947 46.9657 35.1162 44.8428L70.3503 9.57203C71.4106 8.51056 72 7.0944 72 5.67927C72 4.26414 71.4106 2.84796 70.3503 1.78651C68.2296 -0.33639 64.6942 -0.33639 62.5727 1.78651L31.2273 33.1645L23.5681 25.4972Z",
    fill: "url(#paint0_linear_719_8128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_8128",
    x1: 7.86154,
    y1: 0.194333,
    x2: 75.8272,
    y2: 53.9217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99E1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplele);
export default __webpack_public_path__ + "static/media/complele.fdb60337e61d533a9d4f892fe2d594c4.svg";
export { ForwardRef as ReactComponent };